
// raw number int x100 : 1000 = 10€
export function formatPrice(raw) {
    let parts = ((raw||0)/100).toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return `${parts.join(',')}&nbsp;€`;
}